import { Body, Heading, Sheet, calc } from '@hover/blueprint';
import React from 'react';

import { ButtonLink } from 'src/shared/components';
import { Route } from 'src/shared/route';

import { useProTranslate } from '../../hooks';

export const FoundAccountSheet = () => {
  const t = useProTranslate();
  return (
    <Sheet.Contents
      contentKey="found-account-sheet"
      maxContentHeight={{
        base: calc.subtract('100vh', 'var(--motion-overflow)'),
        tablet: undefined,
      }}
    >
      <Body paddingTop={700} textColor="neutral.850" variant="semiBold">
        {t('createAccountSheet.stepTwo')}
      </Body>
      <Heading size="xl">{t('foundAccountSheet.welcomeToHover')}</Heading>
      <ButtonLink
        mb={400}
        size="large"
        to={`${Route.SIGN_UP_ONBOARDING.path}/login`}
        w={1}
      >
        {t('foundAccountSheet.logIn')}
      </ButtonLink>
      <ButtonLink
        size="large"
        to={`${Route.SIGN_UP_ONBOARDING.path}/signup`}
        variant="secondary"
        w={1}
      >
        {t('foundAccountSheet.signUp')}
      </ButtonLink>
    </Sheet.Contents>
  );
};
